import React from 'react'

type TabsProps = {
    activeTab: 'raw' | 'curated';
    onTabChange: (tab: 'raw' | 'curated') => void;
}

const Tabs = ({ activeTab, onTabChange }: TabsProps) => {
    return (
        <div className="tw-border-b outline-blue-950">
            <div className="tw-flex tw-gap-4">
                <button
                    className={`tw-py-2 tw-mr-2 tw-text-sm ${activeTab === 'raw'
                        ? 'tw-border-b tw-border-blue-950 tw-text-blue-950 tw-font-semibold'
                        : 'tw-justify-start tw-text-blue-950 tw-hover:tw-text-gray-700'
                        }`}
                    onClick={() => onTabChange('raw')}
                >
                    Raw
                </button>
                <button
                    className={`tw-py-2 tw-mr-2 tw-text-sm tw-text-blue-950 ${activeTab === 'curated'
                        ? 'tw-border-b tw-border-blue-950 tw-font-semibold'
                        : 'tw-justify-start tw-hover:tw-text-gray-700'
                        }`}
                    onClick={() => onTabChange('curated')}
                >
                    Curated
                </button>
            </div>
        </div>
    );
}

export default Tabs